/**
 * Shows [data-le-from] / [data-le-until] elements only inside their time window
 * (unix timestamps, rendered by snippets/schedule-attrs.liquid), so scheduled
 * badges and labels switch on time even when the page came from cache.
 *
 * On unpublished themes only, ?le_preview_at=2026-10-01T09:00:00+02:00 previews
 * the schedule at that time for the rest of the tab session; ?le_preview_at=off
 * goes back to the real time.
 */
(function () {
  var PREVIEW_STORAGE_KEY = 'le-preview-at';

  function getPreviewTime() {
    var theme = window.Shopify && window.Shopify.theme;
    if (!theme || theme.role === 'main') return null;

    try {
      var param = new URLSearchParams(window.location.search).get('le_preview_at');
      if (param === 'off') sessionStorage.removeItem(PREVIEW_STORAGE_KEY);
      else if (param) sessionStorage.setItem(PREVIEW_STORAGE_KEY, param);

      var previewTime = Date.parse(sessionStorage.getItem(PREVIEW_STORAGE_KEY));
      return isNaN(previewTime) ? null : previewTime / 1000;
    } catch (error) {
      return null;
    }
  }

  var previewTime = getPreviewTime();

  function applySchedule() {
    var now = previewTime !== null ? previewTime : Date.now() / 1000;

    document.querySelectorAll('[data-le-from], [data-le-until]').forEach(function (element) {
      var from = Number(element.getAttribute('data-le-from')) || 0;
      var until = Number(element.getAttribute('data-le-until')) || Infinity;

      element.hidden = now < from || now >= until;
    });
  }

  applySchedule();
  setInterval(applySchedule, 60 * 1000);
})();
